import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import CardsWithAnimation from "../Cards/CardsWithAnimation";
import WizardSteps from "../Forms/Wizard";
import Loader from "react-loader";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

import { dev, prod } from "../../config/config";
import AddNewCard from "../Cards/AddNewCard";

const style = theme => ({
  progress: {
    margin: theme.spacing.unit * 2
  },
  ...sweetAlertStyle,
  ...dashboardStyle
});
class ManageAds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: true,
      alert: null,
      show: false,
      wizard: null,
      config: prod,
      isEditing: false,
      isMounted: false,
      value: 0,
      adData: null,
      update: false,
      ad_1: [],
      ad_2: [],
      ad_3: [],
      ad_4: [],
      ad_5: [],
      ad_space: "1",
      requiredHeight: 0,
      requiredWidth: 0
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.warningWithConfirmMessage = this.warningWithConfirmMessage.bind(this);
    this.successDelete = this.successDelete.bind(this);
    this.getRequiredHeight = this.getRequiredHeight.bind(this);
    this.getRequiredWidth = this.getRequiredWidth.bind(this);
    this.startLiveUpdate = this.startLiveUpdate.bind(this);
    this.liveUpdate = null;
  }

  componentDidUpdate() {
   // console.log("component updating scroll...");
    this.props.scrollToTop();
  }
  handleCancel = () => {
    this.setState({
      isEditing: false
    });
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  handleDelete = (id, data) => {
    this.warningWithConfirmMessage(id, data);
    //console.log("handle delete id => " + id);
  };

  deleteAd = (id, data) => {
    this.setState({ loaded: false });
    firebase
      .firestore()
      .collection(this.state.config.DB_Ads)
      .doc(id)
      .delete()
      .then(() => {
        return firebase
          .storage()
          .ref()
          .child(data.image_ref)
          .delete();
      })
      .then(() => {
        this.setState({ loaded: true });
        this.successDelete();
      })
      .catch(error => {
        this.setState({ loaded: true });
        this.successDelete();
        //console.log("error occured => ", error.message);
      });
  };
  deleteImage = imageRef => {
    var storageRef = firebase
      .storage()
      .ref()
      .child(imageRef);
    return storageRef.delete();
  };

  handleEdit = (id, data) => {
    this.setState({
      isEditing: true,
      adData: {
        id: id,
        data: data
      },
      ad_space: data.ad_space,
      update: true,
      requiredHeight: this.getRequiredHeight(data.ad_space),
      requiredWidth: this.getRequiredWidth(data.ad_space)
    });
  };

  getRequiredWidth = ad_space => {
    if (ad_space === "1" || ad_space === "2" || ad_space === "3") {
      return 180;
    } else if (ad_space === "4" || ad_space === "5") {
      return 120;
    }
  };

  getRequiredHeight = ad_space => {
    if (ad_space === "1") {
      return 268;
    } else if (ad_space === "2" || ad_space === "3") {
      return 130;
    } else if (ad_space === "4" || ad_space === "5") {
      return 340;
    }
  };

  handleAdd = ad_space => {
    this.setState(
      {
        update: false,
        ad_space: ad_space,
        requiredHeight: this.getRequiredHeight(ad_space),
        requiredWidth: this.getRequiredWidth(ad_space)
      },
      () => {
        this.setState({
          isEditing: true
        });
      }
    );
  };

  updateAd = id => {
    firebase
      .firestore()
      .collection(this.state.config.DB_Ads)
      .doc(id)
      .update({ name: "name_changed" })
      .then(() => {
        console.log("update successfull");
      });
  };

  componentWillUnmount = () => {
    if (this.liveUpdate) {
      this.liveUpdate();
    }
  };

  componentDidMount() {
    if (
      firebase.auth().currentUser &&
      firebase.auth().currentUser.email === "dev_admin@proledgers.com"
    ) {
      this.setState(
        {
          config: dev,
          isMounted: true
        },
        () => {
          this.startLiveUpdate();
        }
      );
    } else {
      this.setState({
        isMounted: true
      });
      this.startLiveUpdate();
    }
  }
  startLiveUpdate = () => {
    this.liveUpdate = firebase
      .firestore()
      .collection(this.state.config.DB_Ads)
      .orderBy("time", "desc")
      .onSnapshot(querySnapshot => {
        this.setState({
          ad_1: [],
          ad_2: [],
          ad_3: [],
          ad_4: [],
          ad_5: []
        });
        querySnapshot.forEach(doc => {
          if (this.state.isMounted) {
            switch (doc.data().ad_space) {
              case "1":
                this.setState({ ad_1: [...this.state.ad_1, doc] });
                break;
              case "2":
                this.setState({ ad_2: [...this.state.ad_2, doc] });
                break;
              case "3":
                this.setState({ ad_3: [...this.state.ad_3, doc] });
                break;
              case "4":
                this.setState({ ad_4: [...this.state.ad_4, doc] });
                break;
              case "5":
                this.setState({ ad_5: [...this.state.ad_5, doc] });
                break;
              default:
                break;
            }
          }
        });
      });
  };
  componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  }

  handleFinish = state => {
    this.setState({
      isEditing: false
    });
  };

  warningWithConfirmMessage(id, data) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteAd(id, data)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          <Loader loaded={this.state.loaded}>
            You will not be able to recover this Ad!
          </Loader>
        </SweetAlert>
      )
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  successDelete() {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Deleted!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          Your Ad has been deleted.
        </SweetAlert>
      )
    });
  }
  render() {
    return (
      <div ref="mainPanel">
        <Loader loaded={this.state.loaded}>
          {this.state.alert}
          {this.state.isEditing === false ? (
            <div>
              <h3>Ad Space 1 (180 x 268)</h3>
              <br />
              <hr />
              <GridContainer>
                {this.state.ad_1.map((doc, key) => {
                  return (
                    <GridItem xs={12} sm={6} md={6} lg={3} key={key}>
                      <CardsWithAnimation
                        data={doc.data()}
                        id={doc.id}
                        imgWidth={"180px"}
                        imgHeight={"268"}
                        cardWidth={"210px"}
                        handleDelete={this.handleDelete}
                        handleEdit={this.handleEdit}
                      />
                    </GridItem>
                  );
                })}
                <GridItem xs={6} sm={4} md={3} lg={2}>
                  <AddNewCard
                    handleClick={this.handleAdd}
                    ad_space={"1"}
                    cardWidth={"210px"}
                  />
                </GridItem>
              </GridContainer>
              <h3>Ad Space 2 (180 x 130)</h3>
              <br />
              <GridContainer>
                {this.state.ad_2.map((doc, key) => {
                  return (
                    <GridItem xs={12} sm={6} md={6} lg={3} key={key}>
                      <CardsWithAnimation
                        data={doc.data()}
                        id={doc.id}
                        imgWidth={"180px"}
                        imgHeight={"130"}
                        cardWidth={"210px"}
                        handleDelete={this.handleDelete}
                        handleEdit={this.handleEdit}
                      />
                    </GridItem>
                  );
                })}
                <GridItem xs={12} sm={12} md={3}>
                  <AddNewCard
                    handleClick={this.handleAdd}
                    cardWidth={"210px"}
                    cardHeight={"40"}
                    ad_space={"2"}
                  />
                </GridItem>
              </GridContainer>
              <h3>Ad Space 3 (180 x 130)</h3>
              <br />
              <GridContainer>
                {this.state.ad_3.map((doc, key) => {
                  return (
                    <GridItem xs={12} sm={6} md={6} lg={3} key={key}>
                      <CardsWithAnimation
                        data={doc.data()}
                        id={doc.id}
                        imgWidth={"180px"}
                        imgHeight={"130"}
                        cardWidth={"210px"}
                        handleDelete={this.handleDelete}
                        handleEdit={this.handleEdit}
                      />
                    </GridItem>
                  );
                })}
                <GridItem xs={12} sm={12} md={3}>
                  <AddNewCard
                    handleClick={this.handleAdd}
                    cardWidth={"210px"}
                    cardHeight={"40"}
                    ad_space={"3"}
                  />
                </GridItem>
              </GridContainer>
              <h3>Ad Space 4 (120 x 340)</h3>
              <br />
              <GridContainer>
                {this.state.ad_4.map((doc, key) => {
                  return (
                    <GridItem xs={12} sm={6} md={6} lg={2} key={key}>
                      <CardsWithAnimation
                        data={doc.data()}
                        id={doc.id}
                        imgWidth={"120px"}
                        imgHeight={"330"}
                        cardWidth={"150px"}
                        handleDelete={this.handleDelete}
                        handleEdit={this.handleEdit}
                      />
                    </GridItem>
                  );
                })}
                <GridItem xs={12} sm={6} md={6} lg={2}>
                  <AddNewCard
                    handleClick={this.handleAdd}
                    ad_space={"4"}
                    cardWidth={"210px"}
                    cardHeight={"40"}
                  />
                </GridItem>
              </GridContainer>
              <h3>Ad Space 5 (120 x 340)</h3>
              <br />
              <GridContainer>
                {this.state.ad_5.map((doc, key) => {
                  return (
                    <GridItem xs={12} sm={6} md={6} lg={2} key={key}>
                      <CardsWithAnimation
                        data={doc.data()}
                        id={doc.id}
                        imgWidth={"120px"}
                        imgHeight={"330"}
                        cardWidth={"150px"}
                        handleDelete={this.handleDelete}
                        handleEdit={this.handleEdit}
                      />
                    </GridItem>
                  );
                })}
                <GridItem xs={12} sm={6} md={6} lg={2}>
                  <AddNewCard
                    handleClick={this.handleAdd}
                    ad_space={"5"}
                    cardWidth={"210px"}
                    cardHeight={"40"}
                  />
                </GridItem>
              </GridContainer>
            </div>
          ) : (
            <div id="wizard">
              <WizardSteps
                ad_space={this.state.ad_space}
                requiredWidth={this.state.requiredWidth}
                requiredHeight={this.state.requiredHeight}
                handleFinish={this.handleFinish}
                adData={this.state.adData}
                update={this.state.update}
                handleCancel={this.handleCancel}
              />
            </div>
          )}
        </Loader>
      </div>
    );
  }
}

ManageAds.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(style)(ManageAds);



// WEBPACK FOOTER //
// ./src/views/Dashboard/ManageAds.jsx